import React from "react";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import MailSettingsTab from "./MailSettingsTab";

export default function MailSettingsPage() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="p-8 bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 min-h-[70vh] flex flex-col items-center justify-center text-gray-700 dark:text-gray-300">
        <div className="w-14 h-14 rounded-2xl bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 flex items-center justify-center mb-4">
          <ShieldAlert className="w-7 h-7" />
        </div>
        <h2 className="text-xl font-bold mb-2 text-gray-900 dark:text-white">Erişim Reddedildi</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Mail sistem ayarlarını görüntülemek için lütfen oturum açın.
        </p>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 max-w-[1600px] mx-auto">
      <MailSettingsTab />
    </div>
  );
}
